import { z } from 'zod';

/**
 * Product feedback and support requests (M6, ADR-030 support): from any verified account to
 * the platform administrators. Not for client matters: the form says so.
 */

export const FeedbackCategorySchema = z.enum([
  'problem',
  'question',
  'suggestion',
  'access',
  'account_deletion',
]);
export type FeedbackCategory = z.infer<typeof FeedbackCategorySchema>;

export const CreateFeedbackRequestSchema = z
  .object({
    category: FeedbackCategorySchema,
    message: z.string().trim().min(10).max(2000),
    /** The page the person was on, as a path (no query string). */
    page: z
      .string()
      .regex(/^\/[A-Za-z0-9/_\-.~:@]*$/)
      .max(200)
      .optional(),
  })
  .strict();
export type CreateFeedbackRequest = z.infer<typeof CreateFeedbackRequestSchema>;

export const FeedbackSchema = z.object({
  id: z.string(),
  category: FeedbackCategorySchema,
  message: z.string(),
  page: z.string().nullable(),
  fromUid: z.string(),
  fromName: z.string().nullable(),
  fromEmail: z.string().nullable(),
  createdAt: z.string(),
  status: z.enum(['open', 'closed']),
  closing: z.object({ note: z.string(), byUid: z.string(), at: z.string() }).nullable(),
});
export type Feedback = z.infer<typeof FeedbackSchema>;

export const FeedbackListSchema = z.object({ items: z.array(FeedbackSchema) });
export type FeedbackList = z.infer<typeof FeedbackListSchema>;

export const CloseFeedbackRequestSchema = z
  .object({ note: z.string().trim().min(3).max(2000) })
  .strict();

export const DAILY_FEEDBACK_LIMIT = 10;
